import i18n from 'i18n'

export const getUnitLabel = ({ labelPrefix, labelSuffix, hasEndpoint }) => {
  const NUMBER_REGEX = /\d/g
  const isLabelSuffixNumeric = !!labelSuffix[0].match(NUMBER_REGEX)

  let prefix = isLabelSuffixNumeric ? `${i18n.t(labelPrefix) || i18n.t('Tema')} ` : ''
  const endPoint = hasEndpoint ? '.' : ''

  return `${prefix}${labelSuffix}${endPoint}`
}
